import React, { useRef, useState, useEffect } from 'react';
import {
  FileNameContainer,
  GridContainer,
  GridItem,
  DeleteIconContainer,
  Thumbnail,
  AudioFileContainer,
  GridWrapper,
  TitleWrapper,
  GridContent,
  TitleContent,
} from './styled.grid';
import { IGrid } from '../../../@types/grid';
import { AudioFile } from '../../icons/AudioFile';
import { CloseCircle } from '../../icons/CloseCircle';
import { Headline4, Body5 } from './../../typography';
import { DropdownIcon } from './../../icons/DropdownIcon';
import { Modal } from './../Modal';
import { BottomSheet } from './../BottomSheet';
import AudioPlayer from '../AudioPlayer';
import { DeleteAttachmentModal } from '../../../../app/myAudit/components/QuestionCard/DeleteAttachmentModal';
import { patternAudio, patternImage } from '../../../../utils/constants';

export function Grid ({
  media,
  onDelete,
  isGridOpen,
  handleOpenGrid,
  isView,
  isLoadingImgDelete,
}: IGrid) {
  const content = useRef<HTMLDivElement>();
  const [height, setHeight] = useState<string>('0px');
  const [isModalOpen, setModalOpen] = useState<boolean>(false);
  const [bottomSheetOpen, setBottomSheetOpen] = useState<boolean>(false);
  const [urlModal, setUrlModal] = useState<string>('');
  const [indexAudio, setIndexAudio] = useState<number>(0);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [fileIndex, setFileIndex] = useState<number>(0);
  const [fileId, setFileId] = useState<number>(0);

  useEffect(() => {
    if (isGridOpen && media && media.length > 0) {
      calculateHeight();
    } else {
      setHeight('0px');
    }
  }, [media && media.length, isGridOpen]);

  const audioAttachments =
    media && media.filter((item) => item.type.match(patternAudio));

  function calculateHeight () {
    if (content && content.current && isGridOpen) {
      setHeight(`${content.current.scrollHeight}px`);
    }
  }

  function handleOpenModal (url: string, type: string) {
    if (type.match(patternImage)) {
      setUrlModal(url);
      setModalOpen(true);
    } else {
      const index = audioAttachments!.findIndex((item) => item.url === url);
      setIndexAudio(index);
      setBottomSheetOpen(true);
    }
  }

  function handleShowDeleteModal () {
    setShowDeleteModal(!showDeleteModal);
    setModalOpen(false);
  }

  return (
    <>
      <GridWrapper>
        <TitleWrapper onClick={handleOpenGrid}>
          <TitleContent>
            <Headline4>Media</Headline4>
            <Body5>{media && media.length} media files uploaded</Body5>
          </TitleContent>
          {media && media.length > 0 && (
            <DropdownIcon rotate={isGridOpen ? '0' : '-90'} />
          )}
        </TitleWrapper>
        <GridContainer ref={content} height={height}>
          <GridContent openCard={isGridOpen}>
            {media &&
              media.map((file, index) => (
                <GridItem
                  key={index}
                  onClick={() => handleOpenModal(file.url, file.type)}
                >
                  {file.type.match(patternAudio) && (
                    <AudioFileContainer>
                      <AudioFile />
                    </AudioFileContainer>
                  )}
                  {file.type.match(patternImage) && (
                    <Thumbnail src={file.url} />
                  )}
                  {!isView && (
                    <DeleteIconContainer
                      onClick={(event) => {
                        event.stopPropagation();
                        setFileIndex(index);
                        setFileId(file.id);
                        handleShowDeleteModal();
                      }}
                    >
                      <CloseCircle />
                    </DeleteIconContainer>
                  )}
                  <FileNameContainer>{file.name}</FileNameContainer>
                </GridItem>
              ))}
          </GridContent>
        </GridContainer>
      </GridWrapper>
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          handleModalClose={() => setModalOpen(false)}
          imageUrl={urlModal}
          isShowCloseIcon={true}
        />
      )}
      <BottomSheet
        isOpen={bottomSheetOpen}
        onClose={() => setBottomSheetOpen(false)}
        isLineSeparated={false}
      >
        {bottomSheetOpen && (
          <AudioPlayer urls={audioAttachments} currentFile={indexAudio} />
        )}
      </BottomSheet>
      {showDeleteModal && (
        <DeleteAttachmentModal
          showDeleteModal={showDeleteModal}
          handleAttachmentDelete={onDelete}
          handleShowDeleteModal={handleShowDeleteModal}
          index={fileIndex}
          fileId={fileId}
          name={media && media[fileIndex] && media[fileIndex].name}
          isLoadingImgDelete={isLoadingImgDelete}
        />
      )}
    </>
  );
}
